var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 326,
  height: 189.695,
  viewBox: "0 0 326 189.695"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-313 -243)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M163,0c65.356,0,110.556,31.84,136.642,68.43C309.349,82.047,326,90.808,326,107c0,59.094-97.716,76.8-187.738,76.8S0,166.094,0,107C0,70.48,53.764,77.042,96.58,57.611,122.6,45.8,128.611,0,163,0Z",
  transform: "translate(313 243)",
  fill: "#16273b",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(54 3.109)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 106.515,
  cy: 8.321,
  rx: 106.515,
  ry: 8.321,
  transform: "translate(315.56 412.943)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M761.965,582.6l1,7.321-6.988.665,1-8.985Z",
  transform: "translate(-249.411 -176.794)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M809.5,303.812s.666,8.985.666,9.318-4.659,23.294-4.659,23.294-6.656,12.645,0,12.313,4.659-11.98,4.659-11.98l6.988-19.3-2.995-13.644Z",
  transform: "translate(-329.895 1.495)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M690.69,582.6l-1,7.321,6.988.665-1-8.985Z",
  transform: "translate(-200.1 -176.794)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M836.575,423.746l-1.664,2.329s-1,9.983,0,13.311,2.995,18.635,2.995,19.634.333,1.664,0,2-1.331.333-.666,1,.666,2.662.666,2.662v1.664l4.326,24.625s-2.662,3-.666,3,9.318,0,8.985-3.328l-.666-.333s-1-21.963-.666-22.961a8.494,8.494,0,0,0,0-2.995s-.666-1,0-1.331.666-2.995.666-2.995l2.995-20.3s2.662,13.644,4.326,14.975,1.331,4.659,1.331,4.659l1.331,29.284s-1.331,3.328,0,3.993,6.988,2.995,7.321-.333,2-32.279,2-33.61-.333-2,0-2.995-.333-1,0-1-.666-1-.666-1.664V436.724a24.574,24.574,0,0,1,.666-3.993c.333-.666-.333-1.331,0-2.329s-.666-4.326-.666-4.326l-14.975-3.993Z",
  transform: "translate(-353.638 -86.492)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M860.714,714.872s1.664-1.664-.666-1.664a10.834,10.834,0,0,0-4.326,1l-1.664,5.99s-6.822,5.491.832,4.825,6.489-.166,6.489-.166,2.329-.666,2.662-1.331-.666-10.316-.666-10.316S862.378,715.87,860.714,714.872Z",
  transform: "translate(-366.13 -303.076)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M931.394,714.872s-1.664-1.664.666-1.664a10.832,10.832,0,0,1,4.326,1l1.664,5.99s6.822,5.491-.832,4.825-7.487-.166-7.487-.166-2.329-.666-2.662-1.331,1.664-10.316,1.664-10.316S929.73,715.87,931.394,714.872Z",
  transform: "translate(-422.501 -303.076)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.652,
  cy: 8.652,
  r: 8.652,
  transform: "translate(478.611 261.714)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M847.9,182.372s1.331,6.655,1.331,7.654,5.657,3.993,5.657,3.993l6.323-7.987s-3.993-5.657-3.993-6.988Z",
  transform: "translate(-363.629 94.317)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M829.683,205.59s-2.9-.772-3.78-2.05c0,0-9.2,9.038-9.2,10.7l7.321,12.978s0,4.659.666,4.992,0,0,0,1.331-2,9.983-1.331,11.314,1.331.333.665,2.329-2.329,12.645-2.329,12.645,5.99-2,14.642,1.331,18.968-1.331,18.968-1.331-2.662-5.99-2-7.987-1.664-5.657-1.664-5.657l-1.664-30.615s2.329-13.644.666-14.309l-3.328-1.331-10.657-1.31S834.009,205.257,829.683,205.59Z",
  transform: "translate(-340.424 79.752)",
  fill: "#d0cde1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M817.884,250.526l-3.328,2.329s-1.664,4.992,0,7.321a17.065,17.065,0,0,1,2.329,5.657l6.656-.666Z",
  transform: "translate(-338.275 41.138)",
  fill: "#d0cde1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M825.343,116.144l-1.5-.6s3.138-3.455,7.5-3.154l-1.228-1.352s3-1.2,5.73,1.953a26.635,26.635,0,0,1,4.129,5.8h1.607l-.671,1.477,2.348,1.477-2.41-.265a8.174,8.174,0,0,1-.228,3.825l.065,1.167s-2.793-4.322-2.793-4.923v1.5s-1.5-1.352-1.5-2.253l-.819,1.051-.409-1.652-5.048,1.652.819-1.352-3.138.451,1.228-1.652s-3.547,1.953-3.684,3.605-1.91,3.755-1.91,3.755l-.819-1.5S821.386,118.4,825.343,116.144Z",
  transform: "translate(-344.686 145.079)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("rect", {
  width: 132.238,
  height: 92.893,
  transform: "translate(350.426 328.308)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 33.203,
  height: 57.962,
  transform: "translate(361.558 363.751)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.944,
  height: 8.338,
  transform: "translate(367.699 367.229)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.944,
  height: 8.338,
  transform: "translate(379.675 367.229)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.944,
  height: 8.641,
  transform: "translate(367.699 378.598)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.944,
  height: 8.641,
  transform: "translate(379.675 378.598)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.111,
  cy: 2.111,
  r: 2.111,
  transform: "translate(388.427 394.523)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 65.639,
  height: 55.083,
  transform: "translate(405.893 358.249)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.074,221.624H92.2l10.66-22.287,2.386-4.99,3.121-6.526,2.386-4.99,2.766-5.781H239.478l1.633,5.781,1.411,4.99,1.845,6.526,1.411,4.99Z",
  transform: "translate(244.408 124.173)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 14.203,
  transform: "translate(408.196 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(408.196 383.2)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(408.196 391.453)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.566,
  height: 14.203,
  transform: "translate(411.651 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.566,
  height: 1.727,
  transform: "translate(411.651 383.2)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.566,
  height: 1.727,
  transform: "translate(411.651 391.453)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 14.203,
  transform: "translate(418.56 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(418.56 383.2)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(418.56 391.453)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 14.203,
  transform: "translate(422.015 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(422.015 383.2)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(422.015 391.453)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 14.203,
  transform: "translate(424.383 381.951) rotate(-20.654)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(425.128 383.926) rotate(-20.654)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(428.039 391.649) rotate(-20.654)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.566,
  height: 14.203,
  transform: "translate(463.855 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.566,
  height: 1.727,
  transform: "translate(463.855 383.2)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.566,
  height: 1.727,
  transform: "translate(463.855 391.453)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 14.203,
  transform: "translate(460.208 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(460.208 383.2)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(460.208 391.453)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 14.203,
  transform: "translate(456.754 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(456.754 383.2)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.303,
  height: 1.727,
  transform: "translate(456.754 391.453)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 14.203,
  height: 2.303,
  transform: "translate(449.526 394.429) rotate(-69.346)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.727,
  height: 2.303,
  transform: "translate(453.182 384.731) rotate(-69.346)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.727,
  height: 2.303,
  transform: "translate(450.271 392.453) rotate(-69.346)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 65.639,
  height: 1.343,
  transform: "translate(405.893 395.291)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12.091,
  height: 14.203,
  transform: "translate(434.49 381.088)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.142,
  height: 2.687,
  transform: "translate(437.465 384.159)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.152,
  height: 12.283,
  transform: "translate(438.137 358.249)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.919,
  cy: 1.919,
  r: 1.919,
  transform: "translate(436.793 368.613)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.494,204.618H155.337l2.386-4.99H288.083Z",
  transform: "translate(197.436 107.376)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.75,249.593H133.831l2.386-4.99H275.339Z",
  transform: "translate(213.436 73.917)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M830.849,262.223a25.453,25.453,0,0,0-1.524,9.858,5.2,5.2,0,0,0,.859,2.455h0l-23.608,11.208s-10.667,1.1-8.005,5.763,12.313-2.329,12.313-2.329,25.291-3.66,27.287-7.321,3.328-18.968,3.328-18.968Z",
  transform: "translate(-326.614 32.436)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M923.008,208.937H928s3.66.666,4.659,7.321,2,8.319,1,8.319-12.978-.333-12.978-.666S923.008,208.937,923.008,208.937Z",
  transform: "translate(-417.775 72.078)",
  fill: "#d0cde1"
})))));
export default __webpack_public_path__ + "static/media/illustration-shopify.67e900b9.svg";
export { SvgComponent as ReactComponent };